import React from 'react';
import { createUseStyles, Text, Icon } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotWidgetHeader');

const CopilotWidgetHeader = ({ onClose }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Text type="h4" color="black">
                Sage Copilot
            </Text>
            <Icon name="close" onClick={onClose} size="large" className={classes.closeIcon} />
        </div>
    );
};

export default CopilotWidgetHeader;
